import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Search, Menu, X, Heart } from "lucide-react";
import Logo from "./Logo";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function Header() {
  const { count, setOpen } = useCart();  const { user } = useAuth();
  const nav = useNavigate();
  const [cats, setCats] = useState([]);
  const [q, setQ] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [announcement, setAnnouncement] = useState("Frete grátis acima de R$ 199 • 5% OFF no PIX");

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/settings").then((r) => { if (r.data?.announcement) setAnnouncement(r.data.announcement); }).catch(() => {});
    const open = () => setMenuOpen(true);
    window.addEventListener("lara:open-menu", open);
    return () => window.removeEventListener("lara:open-menu", open);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/busca?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header className="sticky top-0 z-40 bg-[#FFF9FA]/95 backdrop-blur-md border-b border-[#F9E1E8]">
      <div className="bg-[#C9708B] text-white text-center text-xs sm:text-sm py-2 px-4" data-testid="top-announcement">
        {announcement}
      </div>
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-4">
        <button className="lg:hidden text-[#4A3B40]" onClick={() => setMenuOpen(true)} data-testid="menu-toggle">
          <Menu className="w-6 h-6" />
        </button>
        <Logo />
        <nav className="hidden lg:flex items-center gap-4 lg:gap-6 ml-4 lg:ml-6 flex-1 min-w-0">
          <Link to="/" className="nav-link whitespace-nowrap" data-testid="nav-home">Início</Link>
          {cats.slice(0, 5).map((c) => (
            <Link key={c.id} to={`/categoria/${c.slug}`} className="nav-link whitespace-nowrap text-sm lg:text-base" data-testid={`nav-cat-${c.slug}`}>{c.name}</Link>
          ))}
        </nav>
        <form onSubmit={submit} className="hidden lg:flex items-center bg-white border border-[#F9E1E8] rounded-full px-4 py-2 w-56 xl:w-72 shrink-0">
          <Search className="w-4 h-4 text-[#8C7A80]" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Buscar produtos..."
            className="bg-transparent border-0 outline-none text-sm flex-1 ml-2 text-[#4A3B40] placeholder:text-[#8C7A80]"
            data-testid="header-search-input"
          />
        </form>
        <Link to={user ? "/minha-conta" : "/login"} className="text-[#4A3B40] hover:text-[#C9708B]" data-testid="header-account">
          <User className="w-5 h-5" />
        </Link>
        <button
          className="relative text-[#4A3B40] hover:text-[#C9708B]"
          onClick={() => setOpen(true)}
          data-testid="header-cart-button"
        >
          <ShoppingBag className="w-5 h-5" />
          {count > 0 && (
            <span className="absolute -top-2 -right-2 bg-[#C9708B] text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center font-bold">
              {count}
            </span>
          )}
        </button>
      </div>

      {/* Mobile/Tablet sheet */}
      {menuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden" data-testid="mobile-menu">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMenuOpen(false)} />
          <div className="absolute left-0 top-0 bottom-0 w-72 bg-[#FFF9FA] p-5 overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <Logo size="sm" />
              <button onClick={() => setMenuOpen(false)}><X className="w-5 h-5" /></button>
            </div>
            <form onSubmit={submit} className="flex items-center bg-white border border-[#F9E1E8] rounded-full px-4 py-2 mb-4">
              <Search className="w-4 h-4 text-[#8C7A80]" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar..." className="bg-transparent border-0 outline-none text-sm flex-1 ml-2" data-testid="mobile-search-input" />
            </form>
            <nav className="flex flex-col gap-3">
              <Link to="/" onClick={() => setMenuOpen(false)} className="py-2 border-b border-[#F9E1E8] text-[#4A3B40]">Início</Link>
              {cats.map((c) => (
                <Link key={c.id} to={`/categoria/${c.slug}`} onClick={() => setMenuOpen(false)} className="py-2 border-b border-[#F9E1E8] text-[#4A3B40]" data-testid={`mobile-menu-cat-${c.slug}`}>{c.name}</Link>
              ))}
              <button
                onClick={() => { setMenuOpen(false); setOpen(true); }}
                className="py-2 border-b border-[#F9E1E8] text-[#4A3B40] text-left flex items-center justify-between"
                data-testid="mobile-menu-cart"
              >
                <span className="flex items-center gap-2"><ShoppingBag className="w-4 h-4" /> Carrinho</span>
                {count > 0 && <span className="bg-[#C9708B] text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center font-bold">{count}</span>}
              </button>
              <Link to="/minha-conta" onClick={() => setMenuOpen(false)} className="py-2 border-b border-[#F9E1E8] text-[#4A3B40] flex items-center gap-2" data-testid="mobile-menu-account">
                <User className="w-4 h-4" /> Minha conta
              </Link>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}
